/**
 * Created by praveenningappa on 7/6/17.
 */
// TODO: Remove this component after GotoStage Release or use it for any upcoming releases. Mocks the same format as Learn More
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Row, Col, Image } from 'react-bootstrap';
import * as ComingSoonHelper from 'app-lib/helpers/coming-soon-helper';
import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import PageTracker from 'app-lib/helpers/page-tracker';
import Page from 'src/model/page';

export class ComingSoon extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            url: window.location.href
        };
    }

    componentDidMount() {
        PageTracker.lastPage = Page.COMING_SOON;
    }

    setFooter() {
        const {t} = this.props;
        return (
            <section className="footer generic-page-footer lgray">
                <div className="left">
                    <span>{t('channel.footer.powered')}</span>
                </div>
                <div className="right">
                    <span>
                        <a href={`${config.company.termsOfService}`} target="_blank" rel="noopener">
                           {t('channel.footer.tnc')}
                        </a>
                    </span>
                    <span>
                        <a href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener">
                           {t('channel.footer.privacy')}
                        </a>
                    </span>
                    <span>{t('channel.footer.copyright')} {t('channel.footer.company')}</span>
                </div>
            </section>);
    }

    getComingSoonBanner() {
        return (
            <div className="learn-more__banner">
                <Image src={`${config.assets.url}/images/coming-soon/coming-soon-banner.png`} alt="banner-img" responsive />
            </div>);
    }

    getComingSoonContent() {
        return (
            <div className="learn-more__content">
                <Row className="clearfix">
                    <Col sm={3} md={3}>
                        {this.getNavItems()}
                    </Col>
                    <Col sm={9} md={9}>
                          {this.state.url.includes('#newContentPlatform') ? ComingSoonHelper.getNewContentPlatformData() : null}
                          {this.state.url.includes('#optimizeContent') ? ComingSoonHelper.getOptimizeContentData() : null}
                          {this.state.url.includes('#limitViewers') ? ComingSoonHelper.getLimitViewersData() : null}
                          {(this.state.url.indexOf('#') === -1) ? ComingSoonHelper.getNewContentPlatformData() : null}
                    </Col>
                </Row>
            </div>
        );
    }

    handleClick(data) {
        this.setState({url: data.target.href});
    }

    getNavItems() {
        return (
            <div className="learn-more__nav">
                <a
                  className={this.state.url.includes('#newContentPlatform') || (this.state.url.indexOf('#') === -1) ? 'learn-more__linkActive' : null}
                  href="#newContentPlatform" onClick={this.handleClick.bind(this)}
                >
                  New content platform
                </a>
                <a className={this.state.url.includes('#optimizeContent') ? 'learn-more__linkActive' : null} href="#optimizeContent" onClick={this.handleClick.bind(this)}>
                  Optimize content
                </a>
                <a className={this.state.url.includes('#limitViewers') ? 'learn-more__linkActive' : null} href="#limitViewers" onClick={this.handleClick.bind(this)}>
                  Limit viewers
                </a>
            </div>
          );
    }

    render() {
        return (
            <section className="body">
                <div className="learn-more__page">
                    {this.getComingSoonBanner()}
                    {this.getComingSoonContent()}
                    {this.setFooter()}
                </div>
            </section>
        );
    }
}

ComingSoon.propTypes = {
    t: PropTypes.func
};

export default connect(
    null,
    dispatch => bindActionCreators(Object.assign({}, HeaderActions), dispatch)
)(translate(['translation'])(ComingSoon));



// WEBPACK FOOTER //
// ./src/components/coming-soon/coming-soon.js